import { Component, computed, inject, input, output, signal } from '@angular/core';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { UpdateModelCardStrategy } from './update-model-card.strategy';
import type { UpdateModelCardItem } from './update-model-card.interfaces';
import { InitialsPipe, OCP_ANALYTICS, TrackAction } from 'shared';
import { AvatarComponent } from '../../molecules';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

const VISIBLE_LIMIT = 1;

@Component({
  selector: 'ocp-update-model-card',
  templateUrl: './update-model-card.component.html',
  styleUrl: './update-model-card.component.scss',
  imports: [
    TranslatePipe,
    NgTemplateOutlet,
    HlmButtonImports,
    ThemedIconComponent,
    InitialsPipe,
    AvatarComponent,
    HlmCardImports,
    DatePipe,
  ],
})
export class UpdateModelCardComponent {
  readonly items = input.required<UpdateModelCardItem[]>();
  readonly viewModel = output<UpdateModelCardItem>();
  readonly updateModel = output<UpdateModelCardItem>();
  readonly OCP_ANALYTICS = OCP_ANALYTICS;

  protected readonly strategy = inject(UpdateModelCardStrategy);
  protected readonly isExpanded = signal(false);

  protected readonly visibleItems = computed(() =>
    this.isExpanded() ? this.items() : this.items().slice(0, VISIBLE_LIMIT)
  );

  protected readonly hasMoreItems = computed(() => this.items().length > VISIBLE_LIMIT);

  protected toggleExpanded(): void {
    this.isExpanded.update(v => !v);
  }

  @TrackAction(OCP_ANALYTICS.ACTION.CLICK, OCP_ANALYTICS.TOKEN.PROJECTS_UPDATE_MODEL_VIEW)
  protected onView(item: UpdateModelCardItem): void {
    this.viewModel.emit(item);
  }

  @TrackAction(OCP_ANALYTICS.ACTION.CLICK, OCP_ANALYTICS.TOKEN.PROJECTS_UPDATE_MODEL_UPDATE)
  protected onUpdate(item: UpdateModelCardItem): void {
    this.updateModel.emit(item);
  }
}
